// (function () {
//     'use strict';

//     angular.module("imApp").factory("accountingBuntComponentService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getEdit: function (parms) {
//                 return $ihttp.post({
//                     method: 1929,
//                     parameters: parms || {}
//                 });
//             },
//             listInvoices: function (parms) {
//                 return $ihttp.post({
//                     method: 1948,
//                     parameters: parms || {}
//                 });
//             },
//             makeInvoice: function (list) {
//                 return $ihttp.post({
//                     method: 1950,
//                     parameters: list
//                 });
//             },
//             exportAccountingBunt: function (edit) {
//                 return $ihttp.post({
//                     method: 1953,
//                     parameters: edit
//                 });
//             },
//             saveObj: function (edit) {
//                 return $ihttp.post({
//                     method: 1930,
//                     parameters: edit
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
